module.exports = __webpack_public_path__ + "images/diagram-views.svg";